module.exports = __webpack_public_path__ + "img/modelo_assinatura_reuniao.fcdd7a5a.svg";